// extracted by mini-css-extract-plugin
module.exports = {"right":"styles_right__2P9G_"};